<template>
  <div>
    <div class="window">
      <div class="header">
        <img src="https://image.flaticon.com/icons/svg/25/25315.svg" width="8%"/>
        <img src="https://cdn.worldvectorlogo.com/logos/instagram-1.svg" width="25%"/>
        <img src="https://image.flaticon.com/icons/svg/20/20402.svg" width="8%"/>
      </div>
      <div class="content">
        <div class="post">
          <div class="name">
            <img src="https://randomuser.me/api/portraits/women/84.jpg" width="10%" height="10%" class="profile-img"/>
            <p>{{username}}</p>
          </div>
          <img src="https://image.flaticon.com/icons/svg/149/149947.svg" width="5%" style="opacity:0.5;"/>
        </div>
        <div class="post-image">
          <v-progress-circular :value="upload" v-if="loading" color="primary"></v-progress-circular>
          <img :src="img" width="100%"/>
        </div>
        <div class="likes">
          <div class="left-icons" style="text-align: left;">
          <img src="https://image.flaticon.com/icons/svg/25/25424.svg" width="8%"/>
          <img src="https://image.flaticon.com/icons/svg/54/54916.svg" width="8%"/>
          <img src="https://image.flaticon.com/icons/svg/126/126536.svg" width="8%"/>
          </div>
          <img src="https://image.flaticon.com/icons/svg/25/25667.svg" width="6%"/>
        </div>
        <div style="text-align:left;">
          {{username}} {{caption}}
        </div>
        <div class="like-count">
          <img src="https://image.flaticon.com/icons/svg/60/60993.svg" width="4%"/>
          <p>24.1K likes</p>
        </div>
      </div>
      <div class="footer">
        <img src="https://image.flaticon.com/icons/svg/20/20176.svg" width="8%"/>
        <img src="https://image.flaticon.com/icons/svg/149/149852.svg" width="8%"/>
        <img src="https://image.flaticon.com/icons/svg/25/25668.svg" width="8%"/>
        <img src="https://image.flaticon.com/icons/svg/60/60993.svg" width="8%"/>
        <img src="https://image.flaticon.com/icons/svg/64/64096.svg" width="8%"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:[
    'img',
    'username',
    'caption',
    'loading',
    'upload'
  ]
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto');
.window{
  width:320px;
  height:550px;
  background-color:#ffffff;
  display: flex;
  flex-direction: column;
      overflow-y: auto;
}
.window .header{
  display:flex;
  align-items:flex-start;
  flex-direction: row;;
  padding:10px 10px;
  justify-content:space-between;
  background-color:#F9F9F9;
  box-shadow:0 2px 5px 0px #ddd;
}
.window .footer{
  display:flex;
  align-items:flex-end;
  padding:10px 10px;
  justify-content:space-between;
  background-color:#F9F9F9;
  box-shadow:0 -2px 5px 0px #ddd;
}
.window .footer img{
  opacity:0.2;
}
.window .footer img:first-child{
  opacity:1;
}
.window .content{
  display: flex;
  flex-direction: column;
  height:100%;
}
.content .post{
  display: flex;
  align-items:center;
  padding:0px 10px;
  justify-content:space-between;
}
.content .post *{
  padding:5px 0px;
}
.content .post .profile-img{
  border-radius:50%;
}
.content .post .name{
  display: flex;
  justify-content:flex-start;
}
.content .post .name p{
  padding-left:5px;
  font-weight:bold;
  font-size:0.8em;
}

.content .likes{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.content .likes *{
  padding:5px 5px;
}

.content .like-count{
  display: flex;
  align-items: center;
  padding:0px 10px;
}
.content .like-count p{
  font-size:0.7em;
  padding:5px;
  font-weight:bold;
  margin-bottom: 0px !important;
}
footer{
  color:#fff;
  padding-top: 5px;
  font-size:0.8em;
}
footer a{
  color:#aaa;
}
</style>

